import styles from './background-image.module.scss';


export const BackgroundImage = () => {
    return (
        <div
            data-template='background-image'
            aria-hidden="true"
            className={ styles.root }
        />
    );
};
